export enum FirebaseKeys {
  GOOGLE_PAY = 'motor_qatar_renew_googlepay',
  APPLE_PAY = 'motor_qatar_renew_applepay',
  B2S_CAMPAIGN = 'motor_qatar_b2s_2025',
  COINS = 'motor_qatar_car_coins',
  SWITCH_TO_RENEW = 'motor_qatar_new_switchtorenew',
  CORE_APPLE_PAY = 'motor_qatar_core_apple_pay',
  GOOGLE_PAY_NEW = 'qatar_motor_new_google_pay',
}

export const FEATURES = [
  FirebaseKeys.GOOGLE_PAY,
  FirebaseKeys.APPLE_PAY,
  FirebaseKeys.B2S_CAMPAIGN,
  FirebaseKeys.COINS,
  FirebaseKeys.SWITCH_TO_RENEW,
  FirebaseKeys.CORE_APPLE_PAY,
  FirebaseKeys.GOOGLE_PAY_NEW,
];

export const FIREBASE_CONFIG = {
  apiKey: 'AIzaSyDo-2iBOwSMOxkJ5V844A4JBGf74VNzSlA',
  authDomain: 'fb-web-qic.firebaseapp.com',
  projectId: 'fb-web-qic',
  storageBucket: 'fb-web-qic.firebasestorage.app',
  messagingSenderId: '76324519272',
  appId: '1:76324519272:web:c57028814ebaf5048f2add',
  measurementId: 'G-VHSFS6QNTK',
};
